import React from "react";
import { Lightbox } from "@/components/PhotoGallery";

// Visionneuse plein écran d'une image seule (photo de profil, couverture, logo d'église) : même coque que les
// publications (X à gauche, menu ⋯ télécharger / partager / copier le lien à droite, glisser pour fermer).
export const ImageViewer = ({ url, onClose, shareLink = null }) => {
  if (!url) return null;
  return <Lightbox images={[url]} index={0} onIndex={() => {}} onClose={onClose} shareLink={shareLink} downloadUrl={url} downloadKind="image" />;
};
